module.exports = "/_next/static/files/955e2374a6db93c392032cd0cf6b7f9c.png";